import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SettlePayment from "../../../SettlementRequired/SettlePayment";
import { getVendorPendingAccount } from "../../../../redux/features/accounts/Vendor/Approval/pendingAccount";
import AccountApprovalCardsCarousel from "../../../../components/Accounts/Vendor/AccountApprovalDetailsCarousel";
import MultiSelectVendorApproval from "../MultiSelectAccountApproval";
import AccountsDeniedReason from "../../../../components/Accounts/Vendor/AccountsDeniedReson/DeniedReason";

const VendorAccountApproval = () => {
  const dispatch = useDispatch();
  const [selectedTxnCarousel, setSelectedTxnCarousel] = useState({});
  const [showMultiple, setShowMultiple] = useState(false);
  const [deniedReason, setDeniedReason] = useState(false);
  const [deniedReasonData, setDeniedReasonData] = useState({});
  const [showSettlementComponent, setShowSettlementComponent] = useState(false);
  const [page, setPage] = useState(0);
  const VendorPendingApprovals = useSelector(
    (state) => state.pendingAccount.vendor
  );
  const [vendorData, setVendorData] = useState([]);

  const dataAppend = (data, dataToBeAdded) => {
    let appendedData = [];
    let deDupData = [];
    let i = 0;
    data?.forEach((item) => {
      appendedData[i] = item;
      i++;
    });
    dataToBeAdded?.forEach((item) => {
      appendedData[i] = item;
      i++;
    });
    let j = 0;
    appendedData?.forEach((item) => {
      if (
        !deDupData?.find((deDupItem) => deDupItem.vendor_id === item.vendor_id)
      ) {
        deDupData[j] = item;
        j++;
      }
    });
    appendedData = deDupData;
    appendedData.sort(
      (timestamp, nextTimestamp) =>
        Number(nextTimestamp.txn_id) - Number(timestamp.txn_id)
    );
    return appendedData;
  };

  useEffect(() => {
    setVendorData(
      dataAppend(vendorData, VendorPendingApprovals?.accounts || [])
    );
  }, [VendorPendingApprovals]);

  useEffect(() => {
    if (showMultiple) {
      setPage(1);
      setVendorData([]);
    }
    dispatch(getVendorPendingAccount({ page_no: page }));
  }, [showMultiple, page]);

  return !showSettlementComponent ? (
    <div className="min-h-screen h-full overflow-x-scroll overflow-y-scroll bg-[#364949] vendor-txn hide-scrollbar">
      <Box className="selectTxnsHeadingBoxMobile">
        <Box sx={{ display: "flex" }}>
          <Button className="selectTxnSearch">
            <img
              className="selectTxnSearchImg"
              src={require("../../../../assets/Approve transactions/Close.png")}
              alt=""
              srcSet=""
            />
          </Button>
          &nbsp; &nbsp;
          <Box className="selectTxnsHeading">Vendor Transactions</Box>
        </Box>
      </Box>
      {deniedReason && (
        <AccountsDeniedReason
          setDeniedReason={setDeniedReason}
          vendor_id={deniedReasonData.vendor_id}
          dispatchFn={deniedReasonData.dispatchFn}
          setShowStatusCard={deniedReasonData.setShowStatusCard}
        />
      )}
      <Box className="h-full bg-[#364949]">
        {showMultiple ? (
          <MultiSelectVendorApproval data={vendorData} />
        ) : (
          <AccountApprovalCardsCarousel
            records={VendorPendingApprovals?.title.records}
            page={page}
            setPage={setPage}
            setSelectedTxnCarousel={setSelectedTxnCarousel}
            setShowSettlementComponent={setShowSettlementComponent}
            setDeniedReason={setDeniedReason}
            setDeniedReasonData={setDeniedReasonData}
            data={vendorData}
          />
        )}
      </Box>
      <Button
        onClick={() => setShowMultiple(!showMultiple)}
        className="showMultipleBT"
      >
        <img
          className="selectTxnSearchImg"
          src={require("../../../../assets/Approve transactions/Task switcher.png")}
          alt=""
          srcSet=""
        />
      </Button>
    </div>
  ) : (
    <SettlePayment getSelected={() => selectedTxnCarousel} />
  );
};

export default VendorAccountApproval;
